import React, { useMemo } from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { ImageFromField } from '@uncinc/react-drupal-core';
import Loadable from 'react-loadable';

import {
  IMAGE_ILLUSTRATION_TYPE_DOODLE_CORNERS,
  IMAGE_ILLUSTRATION_TYPE_ICON,
  IMAGE_ILLUSTRATION_TYPE_LOTTIE,
} from '../../../config/constants';
import TaxonomyProjectCategories from '../../../implementations/Taxonomy/ProjectCategories';

import doodleCorners from '../../../assets/illustrations/doodle-corners.svg';

// Lazy-load Lottie animations with a delay.
const Lottie = Loadable({
  loader: () => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(import('../../Lottie')), 1000);
    });
  },
  loading: () => <div />,
});

import './style.scss';

const ImageWithIllustration = ({ image, crops, className }) => {
  const classNames = c('ImageWithIllustration', className);

  const id = image.get('target_id', null);
  const type = image.getIn(['entity', 'field_illustration', 0, 'value'], '');
  const lottie = image.get('lottie', Immutable.Map());
  const icon = image.getIn(['entity', 'field_icon', 0, 'entity'], Immutable.Map());

  const Illustration = useMemo(() => {
    switch (type) {
      case IMAGE_ILLUSTRATION_TYPE_LOTTIE:
        return (
          <Lottie path={lottie.get('source')} id={id} position={lottie.get('position')} />
        );

      case IMAGE_ILLUSTRATION_TYPE_DOODLE_CORNERS:
        return (
          <div className="ImageWithIllustration__doodle-corners">
            <img src={doodleCorners} alt="" />
          </div>
        );

      case IMAGE_ILLUSTRATION_TYPE_ICON:
        return (
          <TaxonomyProjectCategories
            entity={icon}
            className="ImageWithIllustration__icon"
          />
        );

      default:
        return null;
    }
  }, [id, type, lottie, icon]);

  return (
    <div className={classNames}>
      {type && Illustration && (
        <div className="ImageWithIllustration__illustration">
          {Illustration}
        </div>
      )}

      <ImageFromField
        field={image}
        imageStyles={crops}
        lazyload
      />
    </div>
  );
};

export default ImageWithIllustration;
